import {ReactElement} from "react";
import {useSelector} from "react-redux";
import {IStore} from "@/redux/defaultStore";
import {useGetUserProfile} from "@/hooks/useGetUserProfile";
import Lightning from "../svgs/lightning.svg?react";
import Tooltip from "@/components/Tooltip";
import {DateTime} from "luxon";

function XpMultiplierTooltip(): ReactElement {

    const fullToken = useSelector((store: IStore) => store.authStore.fullToken);
    const {data: userProfileData} = useGetUserProfile(fullToken);
    const xpMultipliers = userProfileData?.user?.xpMultipliers?.filter((doc) => {
        // Check that the multiplier has not expired.
        return doc.expiresAt >= Date.now();
    });
    const multiplerAmount = xpMultipliers?.reduce((accumulated, doc) => {
        const boost = doc.amount - 1;
        return accumulated + boost;
    }, 1);

    if (!multiplerAmount || multiplerAmount <= 1) {
        return null;
    }

    return (
        <Tooltip
            outsideContent={(
                <div className="xp-multiplier-tooltip">
                    <Lightning/>
                    {multiplerAmount}x
                </div>
            )}
        >
            {xpMultipliers.map((multiplier, index) =>
                <p key={`xp-multiplier-${multiplier.name}-${index}`}>
                    {multiplier.name} expires {DateTime.fromMillis(multiplier.expiresAt).toRelative()}.
                </p>)}
        </Tooltip>
    );
}

export default XpMultiplierTooltip;
